window.GeoTargetingConfig = {
  defaultPopupTitle: "Find Us In Store",
  defaultDirectionsButtonText: "Get directions",
  sessionCookieName: "GeoTargeting_store_popup_opened_session",
  repeatPopupDelayDays: 3,
  repeatPopupStorageKey: "GeoTargeting_store_popup_last_shown_at",

  popup: {
    height: "80vh",
    width: "min(1000px, 92vw)",
    titleMaxPx: 44,
    titleMinPx: 18
  },

  fallback: {
    urlParamKey: "utm_content",
    desktopValue: "nrDesktop",
    mobileValue: "nrMobile"
  },

  defaults: {
    notes: "",
    address1: "",
    address2: "",
    phone: "",
    storePhotoUrl: "",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  }
};

window.GeoTargetingLocations = {
  "ace-hardware-10841-whitehall": {
    storeId: "ace-hardware-10841-whitehall",
    title: "Find Us In Store",
    storeName: "Ace Hardware #10841",
    address1: "10 N MAIN",
    address2: "WHITEHALL, MT 59759",
    phone: "(406) 287-3430",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/10841/StoreImages/Images/StoreFront201211200410556879.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "ace-hardware-and-rental-tod-fedlen": {
    storeId: "ace-hardware-and-rental-tod-fedlen",
    title: "Find Us In Store",
    storeName: "ACE Hardware & Rental",
    address1: "2660 Sheridan Rd",
    address2: "Tod Fedlen, IL 60099",
    phone: "(847) 746-1446",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/04137/StoreImages/Images/StoreFront202412300950403806.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "ace-hardware-of-ne-georgia-hartwell": {
    storeId: "ace-hardware-of-ne-georgia-hartwell",
    title: "Find Us In Store",
    storeName: "Ace Hardware of NE Georgia",
    address1: "108 ATHENS ST",
    address2: "HARTWELL, GA 30643",
    phone: "(706) 961-1113",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipMrx4URE5ybiK4oqkWbRJKx2PTZYExuTatCZ-M6=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "ace-home-and-garden-center-libby": {
    storeId: "ace-home-and-garden-center-libby",
    title: "Find Us In Store",
    storeName: "Ace Home and Garden Center",
    address1: "507 W 9th St Hwy 2 W",
    address2: "Libby, MT 59923",
    phone: "(406) 293-2735",
    notes: "Mon - Fri 8:00am - 7:00pm Sat 8:00am - 6:00pm Sun 9:00am - 5:00pm",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipODN2V-JiAQVQdeeZg4VXNETKG_h0copjogHm8=s680-w680-h510-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "ace-town-and-country-vinita": {
    storeId: "ace-town-and-country-vinita",
    title: "Find Us In Store",
    storeName: "Ace Town & Country",
    address1: "601 E ILLINOIS AVE",
    address2: "VINITA, OK 74301",
    phone: "(918) 256-4223",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/18039/StoreImages/Images/StoreFront202411160255406252.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "ace-ejd-emery-jensen-peabody-peabody": {
    storeId: "ace-ejd-emery-jensen-peabody-peabody",
    title: "Find Us In Store",
    storeName: "ACE/EJD Emery Jensen Peabody",
    address1: "515 Lowel St",
    address2: "Peabody, MA 29206",
    phone: "(217) 360-9876",
    notes: "",
    storePhotoUrl: "",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "alamo-lumber-beeville": {
    storeId: "alamo-lumber-beeville",
    title: "Find Us In Store",
    storeName: "Alamo Lumber",
    address1: "400 South Washington",
    address2: "Beeville, TX 78102",
    phone: "(361) 358-2711",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipPQsSFCs893Jm2BJHv4dKqLwKIQlvoFuXyB1mx8=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "baskin-s-ace-hardware-south-dennis": {
    storeId: "baskin-s-ace-hardware-south-dennis",
    title: "Find Us In Store",
    storeName: "Baskin's Ace Hardware",
    address1: "850 Route 134",
    address2: "South Dennis, MA 02660",
    phone: "(508) 385-3999",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/17075/StoreImages/Images/StoreFront201905090105512793.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "bay-ace-hardware-rising-sun": {
    storeId: "bay-ace-hardware-rising-sun",
    title: "Find Us In Store",
    storeName: "BAY ACE HARDWARE",
    address1: "23 W MAIN ST",
    address2: "RISING SUN, MD 21911",
    phone: "(410) 658-1000",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAGegiO-c5NFcMgpX8lobvbU1J5HUQ3WoNz3KPK2EPfdpyxTBG08x-XFeXcTyAVEeDMhdoGXKkReOsAgVxGAYWIO3wMLMII4ccTrnrrck1N98YVS41-SH3j68jwZCkAgTjFBKebP=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "belgrade-ace-hardware-belgrade": {
    storeId: "belgrade-ace-hardware-belgrade",
    title: "Find Us In Store",
    storeName: "Belgrade ACE Hardware",
    address1: "6280 Jackrabbit Ln",
    address2: "Belgrade, MT 59714",
    phone: "(406) 388-6012",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/16752/StoreImages/Images/StoreFront202512020923239243.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "bill-s-ace-hardware-concord": {
    storeId: "bill-s-ace-hardware-concord",
    title: "Find Us In Store",
    storeName: "BILL'S ACE HARDWARE",
    address1: "4451 CLAYTON RD",
    address2: "CONCORD, CA 94521",
    phone: "(925) 825-4100",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/00898/StoreImages/Images/StoreFront201709280829026618.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "bronson-ace-hardware-bronson": {
    storeId: "bronson-ace-hardware-bronson",
    title: "Find Us In Store",
    storeName: "Bronson Ace Hardware",
    address1: "403 N Hathaway Ave",
    address2: "Bronson, FL 32621",
    phone: "(352) 486-4014",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/17545/StoreImages/Images/StoreFront202509251005425076.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "buche-ace-hardware-winner": {
    storeId: "buche-ace-hardware-winner",
    title: "Find Us In Store",
    storeName: "Buche Ace Hardware",
    address1: "1140 E 5th St",
    address2: "Winner, SD 57580",
    phone: "(605) 842-1140",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/18143/StoreImages/Images/StoreFront202407120141071373.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "building-depot-trading-bv-curacco-miami": {
    storeId: "building-depot-trading-bv-curacco-miami",
    title: "Find Us In Store",
    storeName: "Building Depot Trading BV Curacco",
    address1: "Amcar 10100 NW 25 Street",
    address2: "Miami, FL 33172",
    phone: "(305) 599-8866",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAGfdbprmWXZbbdMV4m2mv2EhDHsnNvApubkkzrUX7RUBpGk368KVED7UzAQ39oF8XzPI55-jYuUJojkJ1Vo83LjYd3ZrHShEghgQVA582uZhwmciiCuATmrpjMtUQaZ916-RNAmhYj7bGWS=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "burgess-feed-and-farm-benton": {
    storeId: "burgess-feed-and-farm-benton",
    title: "Find Us In Store",
    storeName: "Burgess Feed & Farm",
    address1: "5063 Hwy 411",
    address2: "Benton, TN 37307",
    phone: "(423) 338-5315",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAEwKL9LmN0804f-t8femMFBbhTyGqXYT3o8J_Tgeq6q5eWMBnMnCAOxpWUebDjLsYmN8PYE9XbPIBPL4b2TK8-bNvk_15GytBIGSXfmN92hpFrBk3aaqIvXRp2BNZLevSBPxPuD-w=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "butters-ace-hardware-thompsons-station": {
    storeId: "butters-ace-hardware-thompsons-station",
    title: "Find Us In Store",
    storeName: "Butters Ace Hardware",
    address1: "1109 ELLISTON WAY",
    address2: "THOMPSONS STATION, TN 37179",
    phone: "(615) 538-7767",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipOyrvVvVpYh5PAlJFaZOto77iv856Oq1eE1YmfL=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "calcutta-ace-hardware-east-liverpool": {
    storeId: "calcutta-ace-hardware-east-liverpool",
    title: "Find Us In Store",
    storeName: "CALCUTTA ACE HARDWARE",
    address1: "15891 ST RT 170 STE 3",
    address2: "EAST LIVERPOOL, OH 43920",
    phone: "(330) 932-1965",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/16604/StoreImages/Images/StoreFront202102130227166962.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "clovis-ace-hardware-clovis": {
    storeId: "clovis-ace-hardware-clovis",
    title: "Find Us In Store",
    storeName: "Clovis Ace Hardware",
    address1: "1890 Shaw Avenue",
    address2: "Clovis, CA 93611",
    phone: "(559) 325-6730",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAFV029ADE28KyldUq8FuVbZqH8Amm-JCeB6zJuO_7Zs79AR51sd0fnkAPEifJOutXsz2n83wJ176hlShexim2ql62r6-2pcRp0V3qaTj88sTlQB0EzNJVGBtinowABFyPw7LgRM=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "contractors-building-supply-marietta": {
    storeId: "contractors-building-supply-marietta",
    title: "Find Us In Store",
    storeName: "Contractors Building Supply",
    address1: "1310 Green St.",
    address2: "Marietta, OH 45750",
    phone: "(740) 374-4486",
    notes: "",
    storePhotoUrl: "https://doitbest.scene7.com/is/image/doitbest/500x329-contractors-building-logo",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "courtesy-ace-hardware-delta": {
    storeId: "courtesy-ace-hardware-delta",
    title: "Find Us In Store",
    storeName: "COURTESY ACE HARDWARE",
    address1: "126 E MAIN ST",
    address2: "DELTA, UT 84624",
    phone: "(435) 864-2784",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAHiO4_NdlSrbrL6D-ckkciVVC7IOY5ZtxhoUJI1hCNhoJpH4bhnFGcA5z3-0Hf3HIqtWGskj-IVAirAIBZ-IAI8KQsbMxQoMdFe48jI8hB6LRwNwRpKnn7-I2NpAJbRhn2sE7ES=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "d-s-ace-hardware-viera": {
    storeId: "d-s-ace-hardware-viera",
    title: "Find Us In Store",
    storeName: "D's Ace Hardware",
    address1: "5494 Lorkey Lane",
    address2: "Viera, FL 32940",
    phone: "(321) 305-5292",
    notes: "Mon-Sat 7AM-7PM Sunday 8AM-5PM",
    storePhotoUrl: "https://s3-media0.fl.yelpcdn.com/bphoto/IyZfEIAqjjwjYZKvAJZ1gQ/o.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "danville-ace-hardware-danville": {
    storeId: "danville-ace-hardware-danville",
    title: "Find Us In Store",
    storeName: "Danville Ace Hardware",
    address1: "975 Hustonville Rd",
    address2: "Danville, KY 40422",
    phone: "(859) 236-5774",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/16134/StoreImages/Images/StoreFront201808220846077353.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "dill-s-ace-hardware-ocilla": {
    storeId: "dill-s-ace-hardware-ocilla",
    title: "Find Us In Store",
    storeName: "Dill's Ace Hardware",
    address1: "352 FITZGERALD HWY",
    address2: "OCILLA, GA 31774",
    phone: "(229) 468-5281",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/00525/StoreImages/Images/StoreFront202003260239385073.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "dunham-s-do-it-center-wellsboro": {
    storeId: "dunham-s-do-it-center-wellsboro",
    title: "Find Us In Store",
    storeName: "Dunham's Do It Center",
    address1: "8 East Ave",
    address2: "Wellsboro, PA 16901",
    phone: "(570) 724-2217",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Dunhams_Do_It_Center.webp?v=1776878106",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "ecs-unit-tt5030-almandoz-hardware-ltd-medley": {
    storeId: "ecs-unit-tt5030-almandoz-hardware-ltd-medley",
    title: "Find Us In Store",
    storeName: "ECS Unit TT5030 Almandoz Hardware Ltd",
    address1: "11305 NW 122nd Street",
    address2: "Medley, FL 33178",
    phone: "(305) 883-1194",
    notes: "",
    storePhotoUrl: "https://streetviewpixels-pa.googleapis.com/v1/thumbnail?panoid=oAusR_D8okhJ17xqozqxfg&cb_client=search.gws-prod.gps&w=408&h=240&yaw=296.7987&pitch=0&thumbfov=100",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "eldorado-true-value-santa-fe": {
    storeId: "eldorado-true-value-santa-fe",
    title: "Find Us In Store",
    storeName: "Eldorado True Value",
    address1: "7 Caliente Road",
    address2: "Santa Fe, NM 87508",
    phone: "(505) 473-2255",
    notes: "",
    storePhotoUrl: "https://s3-media0.fl.yelpcdn.com/bphoto/BB6vT4D87ePudij7u8Hh5A/ls.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "empire-state-building-supply-inc-huntington-station": {
    storeId: "empire-state-building-supply-inc-huntington-station",
    title: "Find Us In Store",
    storeName: "Empire State Building Supply Inc",
    address1: "51 W Hills Rd",
    address2: "Huntington Station, NY 11746",
    phone: "(631) 201-7000",
    notes: "Mon-Sat 7AM-5PM Sunday Closed",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipPZpTnBqUpJ-slIDqqyinwZ03i612_1Mh-JhVYP=s680-w680-h510-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "escalante-home-center-escalante": {
    storeId: "escalante-home-center-escalante",
    title: "Find Us In Store",
    storeName: "Escalante Home Center",
    address1: "425 E Hwy 12",
    address2: "Escalante, UT 84726",
    phone: "(435) 826-4004",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAF9-REgkH11NZYsKAgSPkFkyflDlbKgtx0EhV66IxWhl51Nv7jUy0DeLYDwjurOw0WQtUs0YCrxL6KXUuzMX18MTrH4wX9TqZwpfHD97McwhlgADh65ruHfOlyICr5rB_GdHXvAVQ=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "gemmen-s-ace-hardware-hudsonville": {
    storeId: "gemmen-s-ace-hardware-hudsonville",
    title: "Find Us In Store",
    storeName: "Gemmen's Ace Hardware",
    address1: "3488 KELLY ST",
    address2: "HUDSONVILLE, MI 49426",
    phone: "(616) 669-1118",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/16678/StoreImages/Images/StoreFront201807190410088070.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "golden-rule-building-supply-guthrie": {
    storeId: "golden-rule-building-supply-guthrie",
    title: "Find Us In Store",
    storeName: "Golden Rule Building Supply",
    address1: "4100 Guthrie Rd",
    address2: "Guthrie, KY 42234",
    phone: "(270) 275-5375",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAEPRxC7WJKN_pSh2vpxjyWhfyg8aW9IOQJMtbNq9S0iiZsxSbgvrhOIg9eOXyhTUfsGiw3DmXnIll8hPOBCLs_euvZFgl5UplZpW1_hUymW5bJlfXgeL_gUt6kpFbxq7bdgA0ZLtg=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "graettinger-hardware-graettinger": {
    storeId: "graettinger-hardware-graettinger",
    title: "Find Us In Store",
    storeName: "Graettinger Hardware",
    address1: "106 W. Robinns Street",
    address2: "Graettinger, IA 51342",
    phone: "(712) 859-3333",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipM_O5VyoE_biSSqse9PYS1jxHdd44cxdDjHMN6S=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "gulf-coast-lumber-and-supply-monticello": {
    storeId: "gulf-coast-lumber-and-supply-monticello",
    title: "Find Us In Store",
    storeName: "GULF COAST LUMBER & SUPPLY",
    address1: "1400 S. JEFFERSON ST",
    address2: "MONTICELLO, FL 32344-0000",
    phone: "(850) 997-2519",
    notes: "",
    storePhotoUrl: "http://hosted.where2getit.com/truevalue/images/truevaluelogo.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "gusick-s-ace-hardware-pound": {
    storeId: "gusick-s-ace-hardware-pound",
    title: "Find Us In Store",
    storeName: "Gusick's Ace Hardware",
    address1: "508 Alma St",
    address2: "Pound, WI 54161",
    phone: "(920) 897-3535",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/00394/StoreImages/Images/StoreFront202112291249423071.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "h-houst-and-son-inc-woodstock": {
    storeId: "h-houst-and-son-inc-woodstock",
    title: "Find Us In Store",
    storeName: "H Houst & Son Inc",
    address1: "4 Mill Hill Road",
    address2: "Woodstock, NY 12498",
    phone: "(845) 679-2115",
    notes: "",
    storePhotoUrl: "https://housthardware.com/wp-content/uploads/2025/02/Houst-Hardware-Rentals-Logo-black.png",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "henkle-s-ace-west-chris-henkle": {
    storeId: "henkle-s-ace-west-chris-henkle",
    title: "Find Us In Store",
    storeName: "Henkle's ACE West",
    address1: "2934 McClelland Blvd",
    address2: "Chris Henkle, MO 64804",
    phone: "(417) 553-4172",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/grass-cs/ANxoTn3cBJs8j3I4RiwCDacobrEJjUJk0yPfIvTKmUMX3aG5UuR442ZuEY9M7-1oNN1jyxzBs2pNXlG3PiOF5ui8SyGtnpmctn2cKA8UhW-i-peG_xSm9VccaRy3jEnZoFbKCNv87kc=s294-w294-h220-n-k-no",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "hillsboro-hardware-lumber-and-farm-supply-hillsboro": {
    storeId: "hillsboro-hardware-lumber-and-farm-supply-hillsboro",
    title: "Find Us In Store",
    storeName: "Hillsboro Hardware Lumber & Farm Supply",
    address1: "110 EAST MAIN STREET",
    address2: "HILLSBORO, IN 47949",
    phone: "765-798-4195",
    notes: "",
    storePhotoUrl: "c671f2_2a668e8de0c84e01ac0b4091fb279a4c~mv2_d_3456_5184_s_4_2.jpg (3456×5184)",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "hilltop-hardware-idabel": {
    storeId: "hilltop-hardware-idabel",
    title: "Find Us In Store",
    storeName: "Hilltop Hardware",
    address1: "1800 SE Washington St",
    address2: "Idabel, OK 74745",
    phone: "(580) 286-7679",
    notes: "",
    storePhotoUrl: "https://static.wixstatic.com/media/c671f2_2a668e8de0c84e01ac0b4091fb279a4c~mv2_d_3456_5184_s_4_2.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "home-decor-group-beverly": {
    storeId: "home-decor-group-beverly",
    title: "Find Us In Store",
    storeName: "Home Decor Group",
    address1: "13 Elliot St.",
    address2: "Beverly, MA 01915",
    phone: "(978) 922-1007",
    notes: "",
    storePhotoUrl: "https://homedecorgroup.com/",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "home-decor-group-peabody": {
    storeId: "home-decor-group-peabody",
    title: "Find Us In Store",
    storeName: "Home Decor Group",
    address1: "515 Lowel St",
    address2: "Peabody, MA 01960",
    phone: "(978) 535-5100",
    notes: "Mon-Fri 6:30 AM–5:30 PM Saturday 7:30 AM–5 PM Sunday Closed",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipN9av0Ip2SRYiuBs4guwSFbBFcuXvVP-tQ2RADg=s680-w680-h510-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "home-hardware-and-variety-boulder-city": {
    storeId: "home-hardware-and-variety-boulder-city",
    title: "Find Us In Store",
    storeName: "Home Hardware & Variety",
    address1: "706 Canyon Rd",
    address2: "Boulder City, NV 89005",
    phone: "(702) 293-4199",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Home_Hardware_Variety_Overson.webp?v=1776877104",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "home-hardware-and-variety-overson": {
    storeId: "home-hardware-and-variety-overson",
    title: "Find Us In Store",
    storeName: "Home Hardware & Variety",
    address1: "387 S Moapa Valley Blvd",
    address2: "Overson, NV 89040",
    phone: "(702) 397-2555",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Home_Hardware_Variety.webp?v=1776876956",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "hoschton-hardware-hoschton": {
    storeId: "hoschton-hardware-hoschton",
    title: "Find Us In Store",
    storeName: "Hoschton Hardware",
    address1: "3843 Hwy 53",
    address2: "Hoschton, GA 30548",
    phone: "(706) 654-2692",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Hoschton_Hardware.webp?v=1776876886",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "islands-ace-hardware-rincon-rincon": {
    storeId: "islands-ace-hardware-rincon-rincon",
    title: "Find Us In Store",
    storeName: "Islands ACE Hardware Rincon",
    address1: "591 S. Columbia Ave.",
    address2: "Rincon, GA 31326",
    phone: "(912) 235-0123",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/18798/StoreImages/Images/StoreFront202410091001545958.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "islands-ace-hardware-savannah-savannah": {
    storeId: "islands-ace-hardware-savannah-savannah",
    title: "Find Us In Store",
    storeName: "Islands ACE Hardware Savannah",
    address1: "318 Johnny Mercer Blvd.",
    address2: "Savannah, GA 31410",
    phone: "(912) 897-1288",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/14407/StoreImages/Images/StoreFront202502180109420787.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "islands-ace-hardware-savannah-2-savannah": {
    storeId: "islands-ace-hardware-savannah-2-savannah",
    title: "Find Us In Store",
    storeName: "Islands ACE Hardware Savannah #2",
    address1: "5698 Ogeehee Rd",
    address2: "Savannah, GA 31405",
    phone: "(912) 219-3619",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/17462/StoreImages/Images/StoreFront202105131000330987.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "j-m-peters-inc-dba-jack-s-home-improvement-wiggins": {
    storeId: "j-m-peters-inc-dba-jack-s-home-improvement-wiggins",
    title: "Find Us In Store",
    storeName: "J.M. PETERS INC. DBA JACK'S HOME IMPROVEMENT",
    address1: "747 HALL STREET",
    address2: "WIGGINS, MS 39577-0000",
    phone: "(601) 528-5393",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipMPOFoiSMTDJymeWCtLB_ovE28_7yeENVYWrGrl=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "jay-s-ace-hardware-ogden": {
    storeId: "jay-s-ace-hardware-ogden",
    title: "Find Us In Store",
    storeName: "Jay's Ace Hardware",
    address1: "4335 Harrison Blvd",
    address2: "Ogden, UT 84403",
    phone: "(801) 452-6010",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/18310/StoreImages/Images/StoreFront202505081053523618.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "johnson-lumber-morgan-hill": {
    storeId: "johnson-lumber-morgan-hill",
    title: "Find Us In Store",
    storeName: "Johnson Lumber",
    address1: "600 Tennant Ave.",
    address2: "Morgan Hill, CA 95037",
    phone: "(408) 778-1550",
    notes: "",
    storePhotoUrl: "https://images.data-axle.com/ce88bddb2d2dd63598f4905ecfe7a52368c1fbd1.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "johnson-s-hardware-rialto": {
    storeId: "johnson-s-hardware-rialto",
    title: "Find Us In Store",
    storeName: "Johnson's Hardware",
    address1: "115 S RIVERSIDE AVE",
    address2: "RIALTO, CA 92376",
    phone: "(909) 875-1821",
    notes: "",
    storePhotoUrl: "https://images.data-axle.com/66ef8b30d8b9fe6de093d380548d0334b1328c35.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "jonnie-chuoke-s-home-and-hdwe-san-antonio": {
    storeId: "jonnie-chuoke-s-home-and-hdwe-san-antonio",
    title: "Find Us In Store",
    storeName: "Jonnie Chuoke's Home & Hdwe",
    address1: "2361 NW Military Hwy",
    address2: "San Antonio, TX 78321",
    phone: "(210) 341-1573",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Jonnie_Chuokes_Home_Hdwe.webp",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "k-and-k-hardware-bettendorf": {
    storeId: "k-and-k-hardware-bettendorf",
    title: "Find Us In Store",
    storeName: "K & K Hardware",
    address1: "1818 Grant St",
    address2: "Bettendorf, IA 52722",
    phone: "(563) 359-4474",
    notes: "",
    storePhotoUrl: "https://th.bing.com/th?id=OLC.4Yc1N+kMj72eyA480x360&rs=1&pid=ImgDetMain&o=7&rm=3",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "k-and-k-hardware-and-lumber-llc-bettendorf": {
    storeId: "k-and-k-hardware-and-lumber-llc-bettendorf",
    title: "Find Us In Store",
    storeName: "K&K Hardware & Lumber, LLC",
    address1: "1818 Grant Street",
    address2: "Bettendorf, IA 52722",
    phone: "(563) 359-4474",
    notes: "",
    storePhotoUrl: "https://storage.googleapis.com/content.ezadtv.com/media/5379/20240822_66c7509551157.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "kerton-lumber-co-holly": {
    storeId: "kerton-lumber-co-holly",
    title: "Find Us In Store",
    storeName: "Kerton Lumber Co",
    address1: "1122 N. Saginaw St",
    address2: "Holly, MI 48442",
    phone: "(248) 634-8951",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipMJNZH_UcOY0tPMFDmsHAzlaqMXiaVhwoEm5su-=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "kowpoke-supply-norton": {
    storeId: "kowpoke-supply-norton",
    title: "Find Us In Store",
    storeName: "Kowpoke Supply",
    address1: "415 E. Holme",
    address2: "Norton, KS 67654",
    phone: "(785) 877-3070",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipOXfS4dkeYdQ2LKQQ2VBszWmordDh2UGSJ4O1dx=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "lemoi-ace-hardware-bette-duprirs": {
    storeId: "lemoi-ace-hardware-bette-duprirs",
    title: "Find Us In Store",
    storeName: "Lemoi Ace Hardware",
    address1: "1008 Davis Street",
    address2: "Bette Duprirs, IL 60201",
    phone: "(847) 328-4900",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/StoreImages/C/store_00084_203x133.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "lockwood-ace-hardware-billings": {
    storeId: "lockwood-ace-hardware-billings",
    title: "Find Us In Store",
    storeName: "Lockwood ACE Hardware",
    address1: "678 Johnson Lane",
    address2: "Billings, MT 59101",
    phone: "(406) 656-1447",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/16338/StoreImages/Images/StoreFront202010070238590470.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "maycrest-hardware-kyle-adair": {
    storeId: "maycrest-hardware-kyle-adair",
    title: "Find Us In Store",
    storeName: "Maycrest Hardware",
    address1: "1609 E Montgomery Cross Road",
    address2: "Kyle Adair, GA 31406",
    phone: "(912) 354-2045",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipPtRvzgP3am33qM-MM0caVaLgs22vE2KqCG022l=w243-h174-n-k-no-nu",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "mazo-hardware-and-rental-mazomanie": {
    storeId: "mazo-hardware-and-rental-mazomanie",
    title: "Find Us In Store",
    storeName: "Mazo Hardware & Rental",
    address1: "17 W Commercial Street",
    address2: "Mazomanie, WI 53560",
    phone: "(608) 795-9919",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/MazoHardware.webp?v=1776875380",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "mcpherson-lumber-mcpherson": {
    storeId: "mcpherson-lumber-mcpherson",
    title: "Find Us In Store",
    storeName: "McPherson Lumber",
    address1: "200 W Euclid",
    address2: "McPherson, KS 67460",
    phone: "(620) 241-4044",
    notes: "",
    storePhotoUrl: "https://ecommerce.doitbeststore.com/media/members/images//6/6/661x371-mcpherson-lumber-location.jpg?qlt=80&fmt=webp",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "menahga-hardware-menahga": {
    storeId: "menahga-hardware-menahga",
    title: "Find Us In Store",
    storeName: "Menahga Hardware",
    address1: "114 Aspen SE",
    address2: "Menahga, MN 56464",
    phone: "(218) 564-4121",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipOd8VAP1Nioc0kE_Gs1yjYqbAbL-RziAmIzVfQi=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "mennear-hardware-ltd-bay-1-sundre": {
    storeId: "mennear-hardware-ltd-bay-1-sundre",
    title: "Find Us In Store",
    storeName: "MENNEAR HARDWARE LTD BAY#1",
    address1: "557 MAIN AVE. WEST",
    address2: "SUNDRE, AB T0M 1X0",
    phone: "+1 403-638-9022",
    notes: "",
    storePhotoUrl: "https://cdn-tp3.mozu.com/24645-m1/cms/files/Theme/Basic/ace-logo.svg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "midlakes-sales-ovid": {
    storeId: "midlakes-sales-ovid",
    title: "Find Us In Store",
    storeName: "Midlakes Sales",
    address1: "6500 Log City Rd",
    address2: "Ovid, NY 14521",
    phone: "(607) 869-9483",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Midlakes_Sales.webp?v=1776875631",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "millersburg-lumber-millersburg": {
    storeId: "millersburg-lumber-millersburg",
    title: "Find Us In Store",
    storeName: "MILLERSBURG LUMBER",
    address1: "235 S BENTON STREET",
    address2: "MILLERSBURG, IN 46543-0000",
    phone: "(574) 642-3158",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipPZ5bSFyNCGZr-X-eWisEWBLcHemC9G_ncTEl4=w243-h304-n-k-no-nu",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "minden-ace-hardware-minden": {
    storeId: "minden-ace-hardware-minden",
    title: "Find Us In Store",
    storeName: "Minden Ace Hardware",
    address1: "807 Homer Rd",
    address2: "Minden, LA 71055",
    phone: "(318) 382-9000",
    notes: "Mon-Fri 7AM-7PM Saturday 8AM-5PM Sunday 1AM-5PM",
    storePhotoUrl: "https://cdn-tp3.mozu.com/24645-m1/cms/files/Theme/Basic/ace-logo.svg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "mountain-view-hardware-n-wilkesboro": {
    storeId: "mountain-view-hardware-n-wilkesboro",
    title: "Find Us In Store",
    storeName: "Mountain View Hardware",
    address1: "5287 Speadway Rd",
    address2: "N. Wilkesboro, NC 28659",
    phone: "(336) 984-2215",
    notes: "",
    storePhotoUrl: "https://static.wixstatic.com/media/52637a_c8364a80887d461a834cdd2e8f0ce695~mv2.png/v1/fill/w_300,h_172,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/.png",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "next-home-and-garden-fort-macleod": {
    storeId: "next-home-and-garden-fort-macleod",
    title: "Find Us In Store",
    storeName: "NEXT HOME AND GARDEN",
    address1: "254-24th Street",
    address2: "Fort Macleod, AB T0L 0Z0",
    phone: "+1 403-557-5030",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipNlnDlkmR4tVrr7XxLmTgJvLQu_4wzWHiowrQgE=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "oakley-farm-and-home-center-oakley": {
    storeId: "oakley-farm-and-home-center-oakley",
    title: "Find Us In Store",
    storeName: "Oakley Farm & Home Center",
    address1: "124 Center",
    address2: "Oakley, KS 67748",
    phone: "(785) 671-3193",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Oakley_Farm_Home_Center.jpg?v=1776875862",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "palos-ace-hardware-palos-heights": {
    storeId: "palos-ace-hardware-palos-heights",
    title: "Find Us In Store",
    storeName: "Palos Ace Hardware",
    address1: "6465 W 127TH ST",
    address2: "PALOS HEIGHTS, IL 60463",
    phone: "(708) 389-0433",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Palos_Ace_Hardware.webp?v=1776876521",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "pennington-s-hdwe-and-scrn-print-madisonville": {
    storeId: "pennington-s-hdwe-and-scrn-print-madisonville",
    title: "Find Us In Store",
    storeName: "Pennington's Hdwe & Scrn Print",
    address1: "497 Hwy 22W",
    address2: "Madisonville, LA 70447",
    phone: "(985) 845-0924",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipN01bEdeG3QC2827khTvX8IJmFmmY6_bqm6G7tl=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "petersen-s-ace-hardware-south-windsor": {
    storeId: "petersen-s-ace-hardware-south-windsor",
    title: "Find Us In Store",
    storeName: "Petersen's Ace Hardware",
    address1: "850 Sullivan Ave",
    address2: "South Windsor, CT 06074",
    phone: "(860) 644-8013",
    notes: "Mon-Thu 7am-6pm Friday 7am-5pm Saturday 8am-5pm Sunday 9am-1pm",
    storePhotoUrl: "https://storage.googleapis.com/content.ezadtv.com/media/1/20211222_61c35ad03da59.png",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "rathdrum-trading-post-hdwe-rathdrum": {
    storeId: "rathdrum-trading-post-hdwe-rathdrum",
    title: "Find Us In Store",
    storeName: "Rathdrum Trading Post Hdwe",
    address1: "6950 W Hwy 53",
    address2: "Rathdrum, ID 83858",
    phone: "(208) 687-4730",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAHkpJTJicdA2ZnJn3k7jACtg3LF6RUYB_kS49hHn6uSiUH4gWFqHFB3oyqhTJAcVEdE_urxJu2524Bwb-X_aa1s0Biv9aZLCaTj1ppT6UMsgP2EP_Iy_JAj931ih2kon-UOrYUl=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "salmon-creek-ace-hardware-vancouver": {
    storeId: "salmon-creek-ace-hardware-vancouver",
    title: "Find Us In Store",
    storeName: "Salmon Creek Ace Hardware",
    address1: "13009 NE Hwy 99 Suite 101",
    address2: "Vancouver, WA 98686",
    phone: "(360) 574-6624",
    notes: "Mon-Sat 8AM-7PM Sunday 9AM-6PM",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/AHVAweoCDdmkqmFXPYtUy-n2iaTNzco7Ke1sIeCgtAgf2-D_NvpceZSRKiiw0O5hys24hfkEsbFRIzg3TcZ8e2BQ6mQEs_2twdW_qEc4vMeyq9cG_KGanF4lNCHHHsVUHbrunVsxkFcW=s680-w680-h510-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "scheer-s-ace-hardware-oak-park": {
    storeId: "scheer-s-ace-hardware-oak-park",
    title: "Find Us In Store",
    storeName: "Scheer's Ace Hardware",
    address1: "8601 W. Nine Mile Road",
    address2: "Oak Park, MI 48237",
    phone: "248-542-1802",
    notes: "Mon - Fri 8:00am - 7:00pm Sat 9:00am - 6:00pm Sun 10:00am - 5:00pm",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/00280/StoreImages/Images/StoreFront201805251149444971.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "sebewaing-ace-hardware-sebewaing": {
    storeId: "sebewaing-ace-hardware-sebewaing",
    title: "Find Us In Store",
    storeName: "SEBEWAING ACE HARDWARE",
    address1: "8840 UNIONVILLE RD",
    address2: "SEBEWAING, MI 48759",
    phone: "(989) 883-2740",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAGH9eonQnIo_4d9NV1k4Tpr1PAw63uLWGm_K_KQXkvG14R7-aRtk8CeZAYCyOZu-yePXvCtnI-GuKpATJn1Ncqxz2NtVl_S_3sHO25CguQxrLtBy2h4FxPSmsxouymlyxholWJj=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "stanford-builder-s-supply-stanford": {
    storeId: "stanford-builder-s-supply-stanford",
    title: "Find Us In Store",
    storeName: "Stanford Builder's Supply",
    address1: "814 East Main Street",
    address2: "Stanford, KY 40484",
    phone: "(606) 365-7331",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAHL7iR48HAgx40nKUHev_hLF1tTkyLVe9nHFUm3u8EI0IrRehDtJxFbRjrvZGYaLBxjY-swGzsfi7TYKh_x8ug7ZWLdsnZSssex0VkExTAa5o_Px1xUE2ntFDrCREJT8R8joxiH=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "stockton-lake-outfitters-greenfield": {
    storeId: "stockton-lake-outfitters-greenfield",
    title: "Find Us In Store",
    storeName: "Stockton Lake Outfitters",
    address1: "324 N. Grand",
    address2: "Greenfield, MO 65661",
    phone: "(417) 637-5253",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/p/AF1QipMfxCorJ7xaWHxG4DLs-8Ax1lkLtrgTE1k6_ujk=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "street-stores-middletown": {
    storeId: "street-stores-middletown",
    title: "Find Us In Store",
    storeName: "Street Stores",
    address1: "450 North Pine St",
    address2: "Middletown, PA 17057",
    phone: "(717) 388-1072",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/StreetStoresWholeSaleHardwareStore.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "sullivan-hardware-baton-rouge": {
    storeId: "sullivan-hardware-baton-rouge",
    title: "Find Us In Store",
    storeName: "Sullivan Hardware",
    address1: "8889A Sullivan Rd",
    address2: "Baton Rouge, LA 70818",
    phone: "(225) 261-3021",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAGtsv5ChxkHljZzGIr158uS9D3tE-9ReblKSNI9_XwbvtSi8Dp3zSMv3v_2ZwnGMQMDqSWX4eBNItNPqxfmzgunt5YRUkRu9aLvaZxYQ2vyAH0kMdmokBZ03SfwmG36fDrOXp-hQw=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "summer-rrh-llc-dba-river-ridge-hardware-dib-spokane": {
    storeId: "summer-rrh-llc-dba-river-ridge-hardware-dib-spokane",
    title: "Find Us In Store",
    storeName: "Summer RRH LLC dba River Ridge Hardware DIB",
    address1: "2803 W Garland Ave",
    address2: "Spokane, WA 99209",
    phone: "(509) 328-0915",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAHSFsCSRs94SHnzyG6mSDHHYGTIFjYMmlJylX6biHSC2p3oMHcHHFfh-qTnimgjaVJJ0FW8t3iIyLYggDo6fcTmWt167lU0IwZy0RryfoKYostvxha9MWwtUbC0DI-tDLPP7_hu=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "tate-building-supply-vonore": {
    storeId: "tate-building-supply-vonore",
    title: "Find Us In Store",
    storeName: "TATE BUILDING SUPPLY",
    address1: "1340 HWY 411",
    address2: "VONORE, TN 37885",
    phone: "(423) 884-2020",
    notes: "",
    storePhotoUrl: "https://lh3.googleusercontent.com/gps-cs-s/APNQkAGeLlzYC4eL6Wqtv_BOm-B1G_zQaat1K6GCwoNKJmEI-IyArychJsAD-t8KX1cb_lZAD845_ck5kRPNA-ozfdBvFDQjaRFu2Yk0jLhNKS9J8wi7oCei7nyLGJK8H0crzKbYm8aT=s1360-w1360-h1020-rw",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "teghtmeyer-ace-hardware-columbia-city": {
    storeId: "teghtmeyer-ace-hardware-columbia-city",
    title: "Find Us In Store",
    storeName: "Teghtmeyer Ace Hardware",
    address1: "200 Diplomat Dr,",
    address2: "Columbia City, IN 46725",
    phone: "(260) 244-5632",
    notes: "Store hours Mon - Fri 7:00am - 7:00pm Sat 7:00am - 7:00pm Sun 10:00am - 2:00pm",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/00455/StoreImages/Images/StoreFront202105141220438046.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?ClientID=sulu&Date=1771084222&Signature=7f1ecf246cbb5e826a192cf8d0a3b738fe150c98",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "terry-s-ace-hardware-pagosa-springs": {
    storeId: "terry-s-ace-hardware-pagosa-springs",
    title: "Find Us In Store",
    storeName: "Terry's ACE Hardware",
    address1: "525 Navajo Trail Dr",
    address2: "Pagosa Springs, CO 81147",
    phone: "(970) 731-4022",
    notes: "",
    storePhotoUrl: "https://localact.azurefd.net/files/l3m-local-client-files/550c37c9ba3d0621f829ae51/Ace_Hardware_Logo.svg.png",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "town-and-country-hugo": {
    storeId: "town-and-country-hugo",
    title: "Find Us In Store",
    storeName: "Town & Country",
    address1: "400 4th Street",
    address2: "Hugo, CO 80821",
    phone: "(719) 743-2512",
    notes: "",
    storePhotoUrl: "https://doitbest.scene7.com/is/image/doitbest/store-banner?qlt=80&fmt=webp",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "tri-county-lumber-dixon": {
    storeId: "tri-county-lumber-dixon",
    title: "Find Us In Store",
    storeName: "Tri County Lumber",
    address1: "205 W 2nd St",
    address2: "Dixon, MO 65459",
    phone: "(573) 759-7112",
    notes: "",
    storePhotoUrl: "http://hosted.where2getit.com/truevalue/images/truevaluelogo.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "united-true-value-oconto-falls": {
    storeId: "united-true-value-oconto-falls",
    title: "Find Us In Store",
    storeName: "United True Value",
    address1: "415 E Highland Dr.",
    address2: "Oconto Falls, WI 54154",
    phone: "(920) 848-2823",
    notes: "",
    storePhotoUrl: "http://hosted.where2getit.com/truevalue/images/truevaluelogo.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "valleyview-building-supply-edmonton": {
    storeId: "valleyview-building-supply-edmonton",
    title: "Find Us In Store",
    storeName: "VALLEYVIEW BUILDING SUPPLY",
    address1: "11510 151 STREET",
    address2: "EDMONTON, AB T5M 3N6",
    phone: "+1 780-414-2850",
    notes: "",
    storePhotoUrl: "https://cdn.sanity.io/images/e1syw5oe/~production/b184dcb36f5c43c713e1a9be74f3562abc7c0414-350x125.png?fm=webp",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "village-ace-hardware-glendale": {
    storeId: "village-ace-hardware-glendale",
    title: "Find Us In Store",
    storeName: "Village ACE Hardware",
    address1: "6246 N Port Washington Rd",
    address2: "Glendale, WI 53127",
    phone: "(414) 961-1143",
    notes: "",
    storePhotoUrl: "https://mystore.blob.core.windows.net/public/MyStore/14366/StoreImages/Images/StoreFront201808030302593889.jpg",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "west-trenton-true-value-hardware-ewing": {
    storeId: "west-trenton-true-value-hardware-ewing",
    title: "Find Us In Store",
    storeName: "West Trenton True Value Hardware",
    address1: "416 W Upper Ferry Road",
    address2: "Ewing, NJ 08628",
    phone: "(609) 882-0811",
    notes: "",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/West-Trenton-True-Value-Hardware.jpg?v=1776175326",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  },

  "woodland-creations-and-home-center-phillipsburg": {
    storeId: "woodland-creations-and-home-center-phillipsburg",
    title: "Find Us In Store",
    storeName: "Woodland Creations & Home Center",
    address1: "421 W. Sutter",
    address2: "Phillipsburg, MT 59858",
    phone: "(406) 859-3297",
    notes: "Mon-Fri 8AM-5PM Saturday 10AM-2PM Sunday Closed",
    storePhotoUrl: "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Woodland_Creations_Home_Center.jpg?v=1776877720",
    mainImageUrl: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?",
    directionsUrl: "https://retique.com/pages/store-locator"
  }

};
